import { SVGProps } from 'react';

export const GithubIcon = ({ className, ...rest }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 24 25"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 0.818604C5.76127 0.818604 0.5 6.21101 0.5 12.8676C0.5 18.1918 3.86763 22.703 8.53616 24.2976C9.12366 24.4078 9.33873 24.0353 9.33873 23.7154C9.33873 23.4269 9.32824 22.6715 9.32299 21.6644C6.05502 22.3935 5.36261 20.0487 5.36261 20.0487C4.82757 18.6587 4.05647 18.2862 4.05647 18.2862C2.99163 17.5361 4.13516 17.5519 4.13516 17.5519C5.3154 17.6358 5.93438 18.7951 5.93438 18.7951C6.98348 20.6362 8.68304 20.1064 9.35446 19.797C9.45938 19.0206 9.76362 18.4856 10.0993 18.1866C7.4923 17.8823 4.74888 16.849 4.74888 12.2329C4.74888 10.9163 5.20525 9.84093 5.95536 9.00164C5.83471 8.6974 5.4308 7.46994 6.07076 5.81235C6.07076 5.81235 7.05692 5.48713 9.30201 7.04505C10.241 6.77753 11.2429 6.64639 12.2448 6.64115C13.2414 6.64639 14.2485 6.77753 15.1875 7.04505C17.4326 5.48713 18.4135 5.81235 18.4135 5.81235C19.0535 7.46994 18.6496 8.6974 18.5289 9.00164C19.279 9.84617 19.7354 10.9215 19.7354 12.2329C19.7354 16.8595 16.9867 17.8771 14.3692 18.1761C14.7888 18.5485 15.1665 19.2829 15.1665 20.4054C15.1665 22.0158 15.1508 23.3167 15.1508 23.7101C15.1508 24.0301 15.3606 24.4078 15.9586 24.2871C20.6376 22.6977 24 18.1866 24 12.8676C24 6.21101 18.7387 0.818604 12.25 0.818604Z"
        fill="inherit"
      />
    </svg>
  );
};

export const DiscordIcon = ({
  className,
  ...rest
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.14 96.36"
      className={className}
      {...rest}
    >
      <path d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1A105.25,105.25,0,0,0,126.6,80.22h0C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,46,96.12,53,91.08,65.69,84.69,65.69Z" />
    </svg>
  );
};

export const TypeScriptIcon = ({
  className,
  ...rest
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 256 256"
      width="256"
      height="256"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      className={className}
      {...rest}
    >
      <path
        d="M20 0h216c11.046 0 20 8.954 20 20v216c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20V20C0 8.954 8.954 0 20 0Z"
        fill="#1CEFA5"
      />
      <path
        d="M150.518 200.475v27.62c4.492 2.302 9.805 4.028 15.938 5.179 6.133 1.151 12.597 1.726 19.393 1.726 6.622 0 12.914-.633 18.874-1.899 5.96-1.266 11.187-3.352 15.678-6.257 4.492-2.906 8.048-6.704 10.669-11.394 2.62-4.689 3.93-10.486 3.93-17.391 0-5.006-.749-9.394-2.246-13.163a30.748 30.748 0 0 0-6.479-10.055c-2.821-2.935-6.205-5.567-10.149-7.898-3.945-2.33-8.394-4.531-13.347-6.602-3.628-1.497-6.881-2.949-9.761-4.359-2.879-1.41-5.327-2.848-7.342-4.316-2.016-1.467-3.571-3.021-4.665-4.661-1.094-1.64-1.641-3.495-1.641-5.567 0-1.899.489-3.61 1.468-5.135s2.362-2.834 4.147-3.927c1.785-1.094 3.973-1.942 6.565-2.547 2.591-.604 5.471-.906 8.638-.906 2.304 0 4.737.173 7.299.518 2.563.345 5.14.877 7.732 1.597a53.669 53.669 0 0 1 7.558 2.719 41.7 41.7 0 0 1 6.781 3.797v-25.807c-4.204-1.611-8.797-2.805-13.778-3.582-4.981-.777-10.697-1.165-17.147-1.165-6.565 0-12.784.705-18.658 2.115-5.874 1.409-11.043 3.61-15.506 6.602-4.463 2.993-7.99 6.805-10.582 11.437-2.591 4.632-3.887 10.17-3.887 16.615 0 8.228 2.375 15.248 7.127 21.06 4.751 5.811 11.963 10.731 21.638 14.759a291.458 291.458 0 0 1 10.625 4.575c3.283 1.496 6.119 3.049 8.509 4.66 2.39 1.611 4.276 3.366 5.658 5.265 1.382 1.899 2.073 4.057 2.073 6.474a9.901 9.901 0 0 1-1.296 4.963c-.863 1.524-2.174 2.848-3.93 3.97-1.756 1.122-3.945 1.999-6.565 2.632-2.62.633-5.687.95-9.2.95-5.989 0-11.92-1.05-17.794-3.151-5.875-2.1-11.317-5.25-16.327-9.451Zm-46.036-68.733H140V109H41v22.742h35.345V233h28.137V131.742Z"
        fill="#0D0F15"
      />
    </svg>
  );
};
